export const TRADE_SUMMARY_FONT_SIZE = {
  xs: 11,
  sm: 12,
  md: 13,
  lg: 14,
};
